import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {antiSpamApi} from '../../../../http/Api';
// import StatusTemplateDomain from "../../../template/status/statusBlock/StatusTemplateDomain";
import StatusTamplate from '../../../template/status/statusBlock/StatusTamplate';
import WhiteListComponent from '../../../template/status/whiteList/WhiteListComponent';
import NotificationTamplateBlock from '../../../template/status/notifications/NotificationTamplateBlock';
import NotificationTamplateBlockPlug from '../../../template/status/notifications/NotificationTamplateBlockPlug';
import PopUpSubscribeTamplate from '../../../template/popUp/PopUpSubscribeTamplate';
import FlagCustomisation from '../../../template/flagCostomisationTamplate/FlagCustomisation';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import {useChanges} from '../../../../hooks/useChanges';
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges';
import {getAntiSpam, getAntiSpamAdvanced} from '../../../../store/AntiSpam';
import './antiSpam.scss';

const StatusAntiSpam = () => {
  const {handleSaveChanges, cancelChanges} = useChanges();
  const {handleSaveAdvanceChanges, cancelAdvanceChanges} = useAdvanceChanges();
  const [isPopUoSubscribe, setIsPopUoSubscribe] = useState(false);
  const {antiSpamGlobalState, antiSpamAdvancedGlobalState} = useSelector((state) => state.antiSpam);
  const {changesDetected} = useSelector((state) => state.changeDetected);
  const {changesAdvanceDetected} = useSelector((state) => state.changeAdvanceDetected);
  const [isSubscribe, setIsSubscribe] = useState(antiSpamGlobalState?.data?.premium);

  return (
    <div className="setting_component_wrap">
      <div className="overview_component_content_head">
        <h4>Anti-Spam</h4>
        <p>
          Prevent unauthorized access and malicious activity by blocking any attempts to use webhook
          to send messages to a Discord server.
        </p>
      </div>
      <div className="status_antiwebhook_content">
        <StatusTamplate data={antiSpamGlobalState} />
        <WhiteListComponent data={antiSpamGlobalState} />
        {!isSubscribe ? (
          <NotificationTamplateBlockPlug setIsPopUpSubscribe={setIsPopUoSubscribe} />
        ) : (
          <NotificationTamplateBlock data={antiSpamGlobalState?.data} />
        )}
        {isPopUoSubscribe && (
          <PopUpSubscribeTamplate
            setIsSubscribe={setIsSubscribe}
            setIsPopUpSubscribe={setIsPopUoSubscribe}
          />
        )}
        {changesDetected && (
          <ChangeDetectedItem
            cancel={cancelChanges}
            onSave={() => handleSaveChanges(antiSpamApi.updateAntiSpam, getAntiSpam)}
          />
        )}
      </div>
      <div className="status_antiwebhook_content">
        <FlagCustomisation
          title={'Advance Settings'}
          text={'In-depth customisation with flexible flag system.'}
          data={antiSpamAdvancedGlobalState?.data}
        />
      </div>
      {changesAdvanceDetected && (
        <ChangeDetectedItem
          cancel={cancelAdvanceChanges}
          onSave={() =>
            handleSaveAdvanceChanges(antiSpamApi.updateAntiSpamAdvanced, getAntiSpamAdvanced)
          }
        />
      )}
    </div>
  );
};

export default StatusAntiSpam;
